module.exports = __webpack_public_path__ + "img/explain_rectangle.5f5365cc.svg";